/* eslint-disable react-hooks/exhaustive-deps */
import {getFeatureMenuItems, getUserMenuItems} from './menus'
import {Header, UserMenu} from './styles'
// import LogoUrl from '@assets/images/logo-white.png'
import LogoUrl from '@assets/images/dticon.png'
import {TenantTitle} from '@components/tenant-title'
import {logout} from '@store/auth'
import {useTenant} from '@store/settings'
import {Layout, Menu} from 'antd'
import React, {useCallback} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Navigate, Outlet, useLocation, useNavigate} from 'react-router-dom'
import {useFetchPatch} from 'helpers/api'
import {useDomain} from 'contexts/DomainContext'

const {Content, Footer} = Layout

const MainLayout = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const {user} = useSelector(state => state.auth)
  const [tenant, setTenant] = useTenant()
  const patchUser = useFetchPatch('users')
  const {terms} = useDomain()
  const signout = useCallback(() => {
    dispatch(logout())
  }, [dispatch])

  const handleClearTenant = useCallback(() => {
    setTenant(null)
    navigate('/tenantdashboard')
  }, [setTenant, navigate])

  const handleSelectTenant = useCallback(
    (tenant, user) => {
      patchUser('me', user, () => {
        window.location.href = '/'
      })
    },
    [patchUser]
  )

  if (!user?.email) {
    // // console.log('TRACE, 'MainLayout !user?.email', 'navigate to /auth')
    return <Navigate to="/auth" />
  }

  return (
    <Layout>
      {/* <div>Current domain: {domain}</div>
      <div>Current tenant: {tenant?.name || 'None'}</div>
      <div>Current theme: {theme?.name || 'None'}</div> */}
      <Header style={{position: 'sticky', top: 0, zIndex: 100, height: '38px', width: '100%', margin: 0, padding: 0}}>
        <div style={{display: 'flex', alignItems: 'center', gap: '1rem', height: '100%', marginLeft: '1rem'}}>
          <div style={{display: 'flex', alignItems: 'center', gap: '0.25rem'}}>
            <a
              className="logo"
              href="https://deltathermalinc.com/"
              target="_blank"
              rel="noreferrer"
              style={{marginLeft: '-5px', marginRight: '2px'}} // tighten spacing
            >
              <img src={LogoUrl} alt="logo" style={{height: '26px'}} />
            </a>
            <span style={{fontSize: '1.35rem', fontWeight: 'bold', padding: 0, margin: 0}}>
              ThermalSafe{' '}
              <span
                style={{
                  fontStyle: 'italic',
                  color: '#ccc',
                  fontWeight: 'bold'
                }}
              >
                for {terms?.title}
              </span>
            </span>
          </div>

          <TenantTitle
            user={user}
            tenant={tenant}
            onClearTenant={handleClearTenant}
            onSelectTenant={handleSelectTenant}
          />
        </div>

        <Menu
          style={{
            position: 'absolute',
            top: 38,
            margin: 0,
            padding: 0,
            height: '2rem',
            width: '80%',
            lineHeight: '2rem'
          }}
          theme="light"
          mode="horizontal"
          selectedKeys={[location.pathname.slice(1)]}
          items={getFeatureMenuItems(user)}
        />
        <Menu
          style={{
            position: 'absolute',
            top: 38,
            right: 0,
            margin: 0,
            padding: 0,
            zIndex: 101,
            height: '2rem',
            width: '20%',
            lineHeight: '2rem',
            justifyContent: 'end'
          }}
          theme="light"
          mode="horizontal"
          items={getUserMenuItems(user, signout)}
        />
      </Header>
      <Content className="site-layout">
        <div>
          <Outlet />
        </div>
      </Content>
      <Footer style={{textAlign: 'center'}}>Delta Thermal ©2025</Footer>
    </Layout>
  )
}

export default MainLayout
